module.exports = __webpack_public_path__ + "static/media/icon_view_top.ed1bf063.svg";